import React from "react";
import GetIcon from "components/GetIcon";
import styles from "styles/OrderButton.module.scss";
import { useContext } from "react";
import { BasketContext } from "context/BasketContext";

const OrderButton = ({ buttonText, phoneNumber }) => {
    const { basketItems, basketTotal: _basketTotal } = useContext(BasketContext);

    const formattedTotal = parseFloat(_basketTotal).toFixed(2);

    // Function to format the WhatsApp message
    const generateWhatsAppMessage = () => {
        let message = "Hola! Aquí está mi orden:\n\n";
        basketItems.forEach((item, index) => {
            const productName = item.name || item.title || item.productName || "Producto sin nombre";
            message += `${index + 1}. ${productName} - Cantidad: ${item.quantity}\n`;
        });
        message += `\nTotal: ₡${formattedTotal}`;
        return encodeURIComponent(message);
    };

    const handleWhatsAppOrder = () => {
        const message = generateWhatsAppMessage();
        window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
    };

    return (
        <button type="button" className={styles.whatsAppButton} onClick={handleWhatsAppOrder}>
            <GetIcon icon="BsBagCheck" size={20} />
            {buttonText}
        </button>
    );
};

export default OrderButton;
